// Единые форматы чисел для всех языков интерфейса: разряды неразрывным пробелом (57 000 000), десятичная запятая (4,9).
// Раньше узбекский показывал «57,000,000», а точка и «.0» попадали в тексты.
const NBSP = '\u00A0';
export function fmtNumber(v) {
  const n = Math.round(Number(v) || 0);
  const s = String(Math.abs(n)).replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
  return n < 0 ? `−${s}` : s;
}

// Телефон в одном виде везде: +998 90 123 45 67 (узбекский номер из 12 цифр); прочие номера: +цифры.
export function fmtPhone(p) {
  const s = String(p || '').replace(/\D/g, '');
  if (!s) return '';
  if (s.length === 12 && s.startsWith('998')) return `+998 ${s.slice(3, 5)} ${s.slice(5, 8)} ${s.slice(8, 10)} ${s.slice(10)}`;
  return `+${s}`;
}

// Дробное число с запятой и без лишнего «,0»: 4.9 → «4,9», 378.0 → «378».
export function fmtDecimal(v, digits = 1) {
  let s = (Number(v) || 0).toFixed(digits);
  if (s.includes('.')) s = s.replace(/0+$/, '').replace(/\.$/, '');
  return s.replace('.', ',');
}

// Подпись валюты: сум для UZS (по языку интерфейса), иначе код валюты. `t` — функция перевода из useT().
export function currencyLabel(code, t) {
  return !code || code === 'UZS' ? t('shared.sumSymbol') : code;
}

// Компактный формат денег/чисел с локализованными единицами (млрд/млн/тыс).
// `t` — функция перевода из useT().
export function fmtCompact(v, t) {
  const n = Number(v) || 0;
  if (!n) return '0';
  const abs = Math.abs(n);
  if (abs >= 1_000_000_000) return `${fmtDecimal(n / 1_000_000_000)} ${t('units.billion')}`;
  if (abs >= 1_000_000)     return `${fmtDecimal(n / 1_000_000)} ${t('units.million')}`;
  if (abs >= 1_000)         return `${fmtDecimal(n / 1_000, 0)} ${t('units.thousand')}`;
  return String(n);
}

// Длительность в секундах → m:ss или h:mm:ss
export function fmtDuration(sec) {
  const s = Math.max(0, Math.round(sec || 0));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const ss = String(s % 60).padStart(2, '0');
  return h > 0 ? `${h}:${String(m).padStart(2, '0')}:${ss}` : `${m}:${ss}`;
}
